import * as actionTypes from '../actions/actionTypes';
import { updateObject } from '../../utils/updateObject';
import {analyticsCategories, initialChartDetailsState, getLocations} from '../../utils/categories';

const initialState = {
    category: analyticsCategories,
    chartDetails: {},
    categoryKpiData: {},
    benchmarkOptions: {
        industries: [],
        occupations: [],
        locations: [...getLocations()],
    }
};

export default function (state = initialState, action) {
    switch (action.type) {
        case actionTypes.ADD_CHART_CHOOSE_CATEGORY_SUCCESS: return updateObject(state, { chartDetails: {...state.chartDetails, ...action.val}});
        case actionTypes.ANALYTICS_CATEGORY_KPI_DATA_FETCHED: return updateObject(state, { categoryKpiData: {...state.categoryKpiData, ...action.val}});
        case actionTypes.CHART_DETAILS_COMPLETED: return updateObject(state, { chartDetails: {...state.chartDetails, ...action.val}});
        case actionTypes.KPI_AGRREGATE_DATA_FETCHED: return updateObject(state, { chartDetails: {...state.chartDetails, ...action.val}});
        case actionTypes.CHART_PRIVACY_SETTINGS_COMPLETED: return updateObject(state, { chartDetails: {...state.chartDetails, ...action.val}});
        case actionTypes.CHART_GO_BACK_PRESSED: return updateObject(state, { chartDetails: {...state.chartDetails, ...action.val}});
        case actionTypes.ADD_CHART_SUCCESS: return updateObject(state, { chartDetails: {...action.val}});
        case actionTypes.EDIT_CHART_SUCCESS: return updateObject(state, { chartDetails: {...action.val}});
        case actionTypes.CHART_LOADED: return updateObject(state, { chartDetails: {...action.val}});
        case actionTypes.LEAVE_CREATE_CHART: return updateObject(state, { chartDetails: {}});   
        case actionTypes.LEAVE_EDIT_CHART: return updateObject(state, { chartDetails: {}});     
         
        default:
            break;
    }
    return state;
}